export default __webpack_public_path__ + "static/operatingPrinciples-3fdde544e900167b5ac7b59e4e28cfa7.svg";